<ul class="sub-menu">
  <li (click)="openTab('trailer')" [ngClass]="{ active: isTrailerOpen }">
    {{ 'semi_trailer' | translate }}
  </li>
  @if (isSet) {
    <li (click)="openTab('semitrailer')" [ngClass]="{ active: isSemitrailerOpen }">
      {{ 'trailer' | translate }}
    </li>
  }
</ul>
<div class="container">
  <form #f="ngForm" class="form" (keyup.enter)="onSubmit()" [formGroup]="form">
    @if (isTrailerOpen) {
      <div class="wheel-form-trailer">
        <div class="input-row">
          <div class="input-container">
            <label class="label">{{ 'door_distance' | translate | unit: 'length':true }}</label>
            <gl-input-container [glPremium]="true" class="input" [isErrorVisible]="true">
              <input [numericType]="'float'" formControlName="distance" normal-input type="text" />
            </gl-input-container>
          </div>
          <div class="input-container">
            <label class="label">{{ 'width_wheel_arches' | translate | unit: 'length':true }}</label>
            <gl-input-container [glPremium]="true" [isErrorVisible]="true">
              <input [numericType]="'float'" formControlName="width" normal-input type="text" />
            </gl-input-container>
          </div>
          <div class="input-container">
            <label class="label">{{ 'height_wheel_arches' | translate | unit: 'length':true }}</label>
            <gl-input-container [glPremium]="true" [isErrorVisible]="true">
              <input [numericType]="'float'" formControlName="height" normal-input type="text" />
            </gl-input-container>
          </div>
          <div class="input-container">
            <label class="label">{{ 'length_wheel_arches' | translate | unit: 'length':true }}</label>
            <gl-input-container [glPremium]="true" [isErrorVisible]="true">
              <input [numericType]="'float'" formControlName="length" normal-input type="text" />
            </gl-input-container>
          </div>
        </div>
      </div>
    }
    @if (isSemitrailerOpen) {
      <div class="wheel-form-semitrailer">
        <div class="input-row">
          <div class="input-container">
            <label class="label">{{ 'door_distance' | translate | unit: 'length':true }}</label>
            <gl-input-container [glPremium]="true" class="input" [isErrorVisible]="true">
              <input [numericType]="'float'" formControlName="distance2" normal-input type="text" />
            </gl-input-container>
          </div>
          <div class="input-container">
            <label class="label">{{ 'width_wheel_arches' | translate | unit: 'length':true }}</label>
            <gl-input-container [glPremium]="true" [isErrorVisible]="true">
              <input [numericType]="'float'" formControlName="width2" normal-input type="text" />
            </gl-input-container>
          </div>
          <div class="input-container">
            <label class="label">{{ 'height_wheel_arches' | translate | unit: 'length':true }}</label>
            <gl-input-container [glPremium]="true" [isErrorVisible]="true">
              <input [numericType]="'float'" formControlName="height2" normal-input type="text" />
            </gl-input-container>
          </div>
          <div class="input-container">
            <label class="label">{{ 'length_wheel_arches' | translate | unit: 'length':true }}</label>
            <gl-input-container [glPremium]="true" [isErrorVisible]="true">
              <input [numericType]="'float'" formControlName="length2" normal-input type="text" />
            </gl-input-container>
          </div>
        </div>
      </div>
    }
    <div class="right-column">
      @if (isTrailerOpen) {
        <div class="visualisation-container">
          <gl-loading-space-preview
            [project]="project"
            [width]="370"
            view="left"
            [height]="220"
            [loadingSpaceType]="loadingSpaceMod"
            [isOrto]="true"
          ></gl-loading-space-preview>
        </div>
      }
      @if (isSemitrailerOpen) {
        <div class="visualisation-container">
          <gl-loading-space-preview
            [project]="project"
            [width]="370"
            view="setLeft"
            [height]="220"
            [loadingSpaceType]="loadingSpaceMod"
            [isOrto]="true"
          ></gl-loading-space-preview>
        </div>
      }
    </div>
  </form>
  <div class="buttonRow">
    <button (click)="formReset()" outline-icon-button>
      <gl-icon name="delete"></gl-icon>
    </button>
    <button (click)="reload()" outline-icon-button>
      <gl-icon name="startArrangement"></gl-icon>
    </button>
  </div>
</div>
